export const EInvoiceStatus = {
  ativa: 'Pendente',
  cancelada: 'Cancelado',
  paga: 'Pago',
} as const

export type InvoiceStatus = keyof typeof EInvoiceStatus

export type Invoice = {
  id: string
  status: InvoiceStatus
  due_date: string
  value: number
  url: string
  barcode: string
}
